import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';

const wikisPage = PageBlueprint.make({
  name: 'wikis',
  params: {
    path: '/wikis',
    title: 'Wikis',
    icon: <LibraryBooksIcon fontSize="inherit" />,
    loader: () => import('./WikisPage').then(m => <m.WikisPage />),
  },
});

export const wikisModule = createFrontendModule({
  pluginId: 'app',
  extensions: [wikisPage],
});
